export const LOGO_SRC = "/images/luckys-kitchen-logo-transparent.png";

export const Logo = ({ className = "h-[5.25rem] w-[5.25rem]" }) => (
  <img
    src={LOGO_SRC}
    alt="Lucky's Kitchen"
    width="1280"
    height="1280"
    decoding="async"
    className={`block shrink-0 object-contain ${className}`}
  />
);
